module.exports = __webpack_public_path__ + "static/img/botian.44870a16.png";